import { httpGet } from 'src/utils/http';

export const apiGetExperimentalToggleEnabled = (flagName: string): Promise<boolean> =>
  httpGet('/FeatureToggle/IsExperimentalToggleEnabled', {
    toggleName: flagName,
  });
